'use client';

import dynamic from 'next/dynamic';

// Import the client component with SSR disabled
const ReviewsClient = dynamic(
  () => import('./ReviewsClient'),
  { ssr: false }
);

export default function ReviewsWrapper() {
  return <ReviewsClient />;
}
